import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pt from 'vuetify/src/locale/pt';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        'primary': '#1565c0',
        'primary-variant-one': '#1ecb88',
        'primary-variant-two': '#00449b',
        'secondary': '#009fb7',
        'success': '#1ecb88',
        'error': '#ef1f65',
        'warning': '#fd693e',
        'light': '#f0f2f5',
        'ice': '#dce1ed',
        'medium': '#a7afc3',
        'grey': '#697785',
        'black': '#424F5B',
      },
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
  icons: {
    iconfont: 'md',
  },
});
